import React from "react";
//#region types
//#endregion
//#region components
import { Skeleton } from "@mui/material";
//#endregion

const AccordianPanelTitleExtraTextSkeleton: React.FC = () => {
  return <Skeleton width={24} height={24} />;
};

export default AccordianPanelTitleExtraTextSkeleton;
